import React, {useState} from 'react';
import i18n from '../../i18n';
import {Typography, withStyles} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import {blue, green} from "@material-ui/core/colors";
import Radio from "@material-ui/core/Radio";
import workTimeSeasonMutations from "../../mutations/workTimeSeasonMutations";
import {getMutationName} from "../Form/utils";
import _ from "lodash";
import swal from "sweetalert";


const GreenRadio = withStyles({
    root: {
        //color: green[300],
        '&$checked': {
            color: green[600],
        },
        '&:hover': {
            color: green[600],
        },
    },
    checked: {},
})((props) =>
    <Radio color="default" {...props} />
);

const BlueRadio = withStyles({
    root: {
        //color: blue[300],
        '&$checked': {
            color: blue[600],
        },
        '&:hover': {
            color: blue[600],
        },
    },
    checked: {},
})((props) =>
    <Radio color="default" {...props} />
);



const saveSeason = async (values) => {

    const mutation = workTimeSeasonMutations.updateWorkTimeSeason;
    const mutationName = getMutationName(mutation);

    if (values && values.length > 0) {
        let res = [];
        let resData = async () => {
            for (const value of values) {
                const {data: result} = await window.apolloClient.mutate({mutation, variables: {...value}})
                    .catch((e) => {
                        console.log('graphQLErrors', e)
                    });
                res.push(result[mutationName]);
            }
            return res;
        };
        return await resData();
    }
}

const SeasonsList = (props) => {
    const {
        values,
        classes
    } = props;

    const [seasons,setSeasons] = useState(_.cloneDeep(values.seasons) || []);
    const [changes,setChanges] = useState([]);

    const handleChange = (event) => {
        let month = event.target.name;
        let id = _.findIndex( seasons, { month: month });
        seasons[id] = { ...values.seasons[id] , season: event.target.value };
        setSeasons([...seasons]);

        if(!_.isEqual(seasons[id],values.seasons[id])) {
            changes.push(seasons[id]);
            setChanges(changes);
        } else {
            let toUnsetId = _.findIndex(changes, { month: month });
            // delete changed object, which was setting to default value
            _.unset(changes,toUnsetId);
            // unset return an empty object
            // empty object will be removed by filter
            let result = _.filter(changes, _.size);
            setChanges(result);
        }
    };

    const handleSubmit = () => {
        swal({
            text: i18n.get('config.work_time.seasons_will_be_saved'),
            icon: 'info',
            button: {
                text: "ok",
                closeModal: false,
            },
            closeOnClickOutside: false,
            closeOnEsc: false,
        }).then(res => {
            if(res) {
                saveSeason(changes).then(() => {
                    return swal({
                        text: i18n.get('config.work_time.seasons_saved'),
                        icon: 'success',
                        timer: 4000,
                    }).then(() => {
                        setChanges([]);
                    });
                });
            }
        });
    };

    return (
        <Grid direction={'column'} container>
            <Typography variant="h6" color={"primary"}>
                {i18n.get('config.work_time.seasons')}
            </Typography>
            <Grid item container direction={'row'} justify={'space-between'} alignItems={"center"} className={classes.gridHeader}>
                <Grid item>{i18n.get('config.work_time.months')}</Grid>
                <Grid item style={{marginRight:10}}>
                    <span className={classes.green}>{i18n.get('config.work_time.summer')}</span>
                    <span style={{display:'inline-block', width: 10}} />
                    <span className={classes.blue}>{i18n.get('config.work_time.winter')}</span>
                </Grid>
            </Grid>
            <Divider className={classes.divider} style={{marginTop:10}}/>
            {Object.values(seasons).map((data,id) =>
                <Grid key={id} item container direction={'row'} justify={'space-between'} alignItems={"center"}>

                    <Grid item>
                        {i18n.get('config.work_time.' + data.month)}
                    </Grid>
                    <Grid item>
                        <RadioGroup aria-label={data.month} name={data.month} value={data.season} onChange={handleChange} row>
                            <FormControlLabel value={'summer'} control={<GreenRadio />} label="" style={{marginBottom:0}} />
                            <FormControlLabel value={'winter'} control={<BlueRadio />} label="" style={{marginBottom:0}} />
                        </RadioGroup>
                    </Grid>
                </Grid>
            )}
            <Divider className={classes.divider}/>
            <Grid item style={{textAlign:'right',paddingTop:10}}>
                <Button
                    component={'a'}
                    type="submit"
                    name={'submitter'}
                    size="small"
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                >
                    <Icon fontSize="small">save</Icon>
                    &nbsp;
                    {i18n.get('config.work_time.save_config')}
                </Button>
            </Grid>
        </Grid>
    );
}

const styles = theme => ({
    divider: {
        marginTop: theme.spacing.unit * 2,
    },
    vSpace: {
        marginTop: theme.spacing.unit * 2,
    },
    spacing: {
        marginTop: theme.spacing.unit * 2
    },
    span: {
        display: 'inline',
        margin: '0 5px',
    },
    gridHeader: {
        color: 'rgba(0, 0, 0, 0.54)',
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
        fontSize: '0.75rem',
        fontWeight: 500,
        marginTop: theme.spacing.unit * 1.35,
    },
    green: {
        color: green[600],
    },
    blue: {
        color: blue[600],
    },
});

export default withStyles(styles)(SeasonsList);
